module.exports = "mat-card{\r\n    min-height : 300px;\r\n}"